import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";

import { VegaModulesPaths } from "../paths";

export const useResourcesRoute = (): VegaModulesPaths => {
  const { featureFlag } = useFeatureFlag();

  return featureFlag[FeatureFlag.VEGA_CMS_MIGRATION]
    ? VegaModulesPaths.ResourcesCms
    : VegaModulesPaths.ResourcesRoot;
};
